export default function parseSpecificDate({ monthDayYear, hourMinute }) {
  const { month, day, year } = monthDayYear;
  const { hour, minute } = hourMinute;

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute)
  );
}
